import React, { useState } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

import imagen00 from '../Fotos/adventures/bici/image00.jpg'
import imagen01 from '../Fotos/adventures/bici/image01.jpg'
import imagen02 from '../Fotos/adventures/bici/image02.jpg'
import imagen03 from '../Fotos/adventures/bici/image03.jfif'
import imagen04 from '../Fotos/adventures/bici/image04.jfif'
import imagen05 from '../Fotos/adventures/bici/image05.jpg'
import imagen06 from '../Fotos/adventures/bici/image06.jfif'
import imagen07 from '../Fotos/adventures/bici/image07.jpg'
import imagen08 from '../Fotos/adventures/bici/image08.jfif'
import imagen09 from '../Fotos/adventures/bici/image09.jpg'
import imagen10 from '../Fotos/adventures/bici/image10.jpg'
import imagen11 from '../Fotos/adventures/bici/image11.jpg'
import imagen12 from '../Fotos/adventures/bici/image12.jfif'
import imagen13 from '../Fotos/adventures/bici/image13.jfif'
import imagen14 from '../Fotos/adventures/bici/image14.jfif'
import imagen15 from '../Fotos/adventures/bici/image15.jpg'
import imagen16 from '../Fotos/adventures/bici/image16.jpg'
import imagen17 from '../Fotos/adventures/bici/image17.jpg'


const items = [
  {
    src: imagen00    
  },
  {
    src: imagen01    
  },
  {
    src: imagen02    
  },   
  {
    src: imagen05   
  },  
  {
    src: imagen07    
  },   
  {
    src: imagen09    
  }, 
  {
    src: imagen10    
  }, 
  {
    src: imagen11    
  },   
  {
    src: imagen15    
  },
  {
    src: imagen16    
  },
  {
    src: imagen17    
  },

];

//MOTOS

// import imagen01 from '../Fotos/adventures/motos/image01.jpg'
// import imagen02 from '../Fotos/adventures/motos/image02.jpg'
// import imagen03 from '../Fotos/adventures/motos/image03.jpg'
// import imagen04 from '../Fotos/adventures/motos/image04.jpg'
// import imagen05 from '../Fotos/adventures/motos/image05.jpg'
// import imagen06 from '../Fotos/adventures/motos/image06.jpg'
// import imagen07 from '../Fotos/adventures/motos/image07.jpg'
// import imagen08 from '../Fotos/adventures/motos/image08.jpg'
// import imagen09 from '../Fotos/adventures/motos/image09.jpg'
// import imagen10 from '../Fotos/adventures/motos/image10.jpg'
// import imagen11 from '../Fotos/adventures/motos/image11.jpg'
// import imagen12 from '../Fotos/adventures/motos/image12.jpg'


// const items = [
//   {
//     src: imagen01    
//   },
//   {
//     src: imagen04    
//   },
//   {
//     src: imagen02    
//   },  
//   {
//     src: imagen03    
//   },
//   {
//     src: imagen05    
//   },
//   {
//     src: imagen06    
//   }, 
//   {
//     src: imagen07    
//   }, 
//   {
//     src: imagen08    
//   }, 
//   {
//     src: imagen09    
//   }, 
//   {
//     src: imagen10    
//   }, 
//   {
//     src: imagen11    
//   }, 
//   {
//     src: imagen12    
//   }  
// ];

//MOTOS

export const Slide = () => {

  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        <img src={item.src} alt={item.altText} className="img-slider-size" />
        <CarouselCaption captionText={item.caption} captionHeader={item.caption} />
      </CarouselItem>
    );
  });


  return (

    <div>
      <Carousel
        activeIndex={activeIndex}
        next={next}
        previous={previous}
      >
        <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
        {slides}
        <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
        <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      </Carousel>
    </div>

  )
}
